<template>
  <div class="form tab-content">
    <template v-for="field in customFields">
      <input-field
        v-if="field.input_type === 'checkbox'"
        :key="field.id"
        ref="formInputField"
        :value="getValueInObject(field.uuid)"
        :label="' '"
        :inputType="field.input_type"
        :size="field.size"
        :required="field.required"
        :required-filled="requiredFilled"
        :checkboxOptions="[field]"
        :fieldDisabled="field.disable"
        :formDisabled="disabled"
        :object-data="objectData"
        @updateCheckboxValue="updateValue(field.uuid, $event)"
      />

      <input-field
        v-else
        :key="field.id"
        ref="formInputField"
        :value="getValueInObject(field.uuid, field.input_type)"
        :label="field.label"
        :inputType="field.input_type"
        :size="field.size"
        :required="field.required"
        :required-filled="requiredFilled"
        :selectOptions="field.list_name"
        :clearable="true"
        :fieldDisabled="field.disable"
        :formDisabled="disabled"
        @input="updateValue(field.uuid, $event)"
      />
    </template>
  </div>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField.vue";
import _ from "lodash";

export default {
  name: "CustomFieldsTab",

  components: { InputField },

  props: {
    objectData: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    customFields: {
      type: Array
    },
    requiredFilled: {
      type: Boolean
    },
    actionType: {
      type: String
    }
  },

  mounted() {
    this.customFields.sort((a, b) => {
      if (a.index === b.index) {
        return 0;
      } else if (a.index === null) {
        return 1;
      } else if (b.index === null) {
        return -1;
      } else {
        return a.index - b.index;
      }
    });
  },

  methods: {
    /**
     * Gets the (nested) objectData corresponding to a string key, with a new value
     * @param {String} varName - path to the variable we're trying to access.
     *
     */
    getValueInObject(varName, input) {
      if (input === "multiselect") {
        let data = _.get(this.objectData, varName);
        if (typeof data === "string") {
          let parsed = JSON.parse(data);
          return parsed;
        }
        return data;
      }
      return _.get(this.objectData, varName);
    },
    /**
     * @param {String} varName - path to the variable we're trying to access.
     * @param {String} change - updated value
     * @param {object} change - if change has type checkbox, change value is an object.
     *
     * @emits String - the type variable has the purpose to identify the component and in dynamicObjectFormsMixin send the data
     * to the respective place ObjectData.custom_fields.
     *
     */
    updateValue(varName, change) {
      let type = "custom_fields";
      if (change && change.type === "checkbox") {
        this.$emit("updateValue", varName, change.newValue, type);
      } else {
        this.$emit("updateValue", varName, change, type);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue